<template>
	<v-app height-100>

		<AtlasNav/>

		<v-container 
			id="landing-intro-bg"
			class="grey lighten-5 height-100 ma-0 pa-0"
			fluid
			:style="{ backgroundImage: 'url(' + require('@/assets/app/landing-page/'+backgroundImgSrc) + ')' }"
		>

			<v-row
				justify="center"
				class="bg-color-dark px-5"
			>

				<v-col
					cols="12" 
					md="8"
					lg="6"
					class="d-flex align-center"
				>

					<div>

						<h1 class="intro-title mb-5">Atlasai istorijoms pasakoti</h1>
						
						<h2 class="intro-subtitle mb-5">
							Interneto įrankiai interaktyviems ir spausdinimui skirtiems atlasams kurti. Turiniui galite naudoti šimtus žemėlapių šaltinių!
						</h2>

						<v-btn large rounded color="primary" dark to='/my-content'>pradėkite kurti atlasą
						</v-btn>

					</div>

				</v-col>

			</v-row>

		</v-container>
		<v-container id="main-description" class="landing-description container-wrapper">
			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					md="6"
					class="pa-10"		
				>
					<h3 class="pb-6">
						Interaktyvūs atlasai – prezentacijos su interaktyviais žemėlapiais
					</h3>
					<p>
						Kurkite istorijas pasakojančias prezentacijas į jas įterpdami dinamiškus žemėlapius su įjungiamais/išjungiamais sluoksniais, keičiamu masteliu, 
						turiniu išplėstu tekstais, nuorodomis, nuotraukomis, video. Kurkite atlaso puslapius su dviem ir daugiau žemėlapių viename ekrane. Žymėkite 
						žemėlapiuose objektus, jiems suteikite pavadinimus, pridėkite nuotraukas ir aprašymus, gaukite prezentaciją, kurioje paeiliui rodomi objektai 
						pasakoja savo istoriją. 
					</p>
					<p>
						<router-link to="/my-content">
							<strong>Kurti interaktyvų atlasą</strong>
						</router-link>
					</p>
				</v-col>
				<v-col
					cols="12"
					md="6"
					class="pa-10"
				>
					<v-img 
						contain 
						src="@/assets/app/landing-page/feature_1.jpg" 
						>
					</v-img>
				</v-col>
			</v-row>
			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					lg="6"
					md="6"
					class="pa-10"
				>
					<v-img  
						contain
						src="@/assets/app/landing-page/feature_2.jpg" 
						>
					</v-img>
				</v-col>
				<v-col
					cols="12"
					md="6"
					class="pa-10"		
				>
					<h3 class="pb-6">
						Greitesnis ir patogesnis būdas spausdinti žemėlapius
					</h3>
					<p>
						Pasirenkite žemėlapius ir duomenis, mastelį, lapo formatą, orientaciją ir gaukite jums pritaikytą, spausdinimui parengtą žemėlapių rinkinį. 
						Žemėlapių rinkinių kūrimo įrankis suskaidys jūsų pasirinktą teritoriją į atskirus lapus-žemėlapius, juos sunumeruos ir susies į vieną dokumentą. 
					</p>
					<p>
						<router-link to="/my-content">
							<strong>Kurti spausdinimui skirtą atlasą</strong>
						</router-link>
					</p>
				</v-col>
			</v-row>
			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					md="6"
					class="pa-10"		
				>
					<h3 class="pb-6">
						Atlasai, kuriais lengva dalintis
					</h3>
					<p>
						Pristatydami savo idėjas ir istorijas dalinkitės sukurtais atlasais auditorijoje, susitikime, viešai ar su jūsų susikurta grupe internete. 
						Bendradarbiaukite kurdami atlasus: dalinkitės ne tik galutiniu rezultatu, bet ir atlaso redagavimo teisėmis. Susikurkite reprezentacinę svetainę - 
						interaktyvaus atlaso įvadinis puslapis su Jūsų sukurtu turiniu.
					</p>
				</v-col>
				<v-col
					cols="12"
					md="6"
					class="pa-10"
				>
					<v-img  
						contain
						src="@/assets/app/landing-page/feature_3.jpg" 
						width=400
						>
					</v-img>
				</v-col>
			</v-row>
			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					lg="6"
					md="6"
					class="pa-10"
				>
					<v-img  
						contain
						src="@/assets/app/landing-page/feature_4.jpg" 
						>
					</v-img>
				</v-col>
				<v-col
					cols="12"
					md="6"
					class="pa-10"		
				>
					<h3 class="pb-6">
						Pradėkite kurti panaudodami šimtus viešų žemėlapių
					</h3>
					<p>
						Kurdami atlasą naudokite šimtus Lietuvos erdvinės informacijos portale geoportal.lt pasiekiamų erdvinių duomenų rinkinių. Topografinius, ortofoto,
						istorinius, aplinkos, žemės ir miškų ūkio, kadastrų ir registrų teikiamus duomenis lengvai integruosite į savo kuriamus atlasus. Kurkite savo duomenis 
						pasinaudoję geoportal.lt erdvinių duomenų valdymo paslauga. 
					</p>
				</v-col>
			</v-row>
		</v-container>
		<v-container class="landing-description">
			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					class="text-center"
				>
					<h3 class="pb-6">Įkvėpimui turime keletą idėjų</h3>
					<p>
						Įdomiausių atlasų kolekcija - Jūsų smalsumui. Kurkite, dalinkitės, pristatykite savo idėjas. 
					</p>

				</v-col>

			</v-row>

			<v-row
				class="pb-12"
				v-if="list"
			>

				<template v-if="list == 'error'">
					<div>Deja, atlasų sąrašo gauti nepavyko...</div>
				</template>
				<template v-else>
					<template v-for="(atlas, i) in list.slice(0,8)">
						<AtlasPreviewTitle
							:atlas="atlas"
							:key="i"
							:class="[i ? '' : '']"
							:getList="getList"
						/>
					</template>
				</template>

			</v-row>
		</v-container>

		<InfoCreateAtlas />
		
		<v-footer class="white">
			<Footer />
		</v-footer>
		
	</v-app>
	
</template>

<script>
	//import Header from "../Header";
	import AtlasNav from "../header/AtlasNav";
	import Footer from "../footer/FooterTitle";
	//import CommonComponents from "../CommonComponents";
	import AtlasHelper from "../helpers/AtlasHelper";
	import AtlasPreviewTitle from "../atlas/AtlasPreviewTitle";
	import CommonHelper from "../helpers/CommonHelper";
	import InfoCreateAtlas from "../gui-elements/InfoCreateAtlas";

	export default {
		components: {
			//Header,
			AtlasNav,
			Footer,
			//CommonComponents
			AtlasPreviewTitle,
			InfoCreateAtlas
		},
		data: function(){
			var data = {
				isAdmin: CommonHelper.isUserAdmin(),
				isLoggedIn: CommonHelper.isUserSigned(),	// Andrius B. FIX ME - čia turėtų būti patikrinama, ar vartotojas prisijungęs. Dabar default laikoma, kad taip.
				features: [],
				step: 0,
				backgroundImgSrc: "intro-bg.jpg",
				drawer: false,
				loading: true,
				list: null
			};
			return data;
		},
		created(){
			this.getList();
		},
		methods: {
			getList: function(){
				this.loading = true;
				AtlasHelper.getPublicListByFilter('', location.host == "www.geoportal.lt" ? "geoportal_admin" : "Svecias1").then(function(list){
					this.loading = false;
					this.list = list;
				}.bind(this), function(){
					this.loading = false;
					this.list = "error";
				}.bind(this));
			},
		}
	};
</script>

<style scoped>

	html {
		margin: 0px; 
		padding: 0px; 
		width: 100%;
	}

	.height-100 {
		height: 100vh;
	}

	.intro-subtitle {
		color: rgba(227, 231, 238, 0.80);
		font-size: 24px;
		line-height: 1.8em;
		font-weight: 400;
		font-size: 24px;
	}

	#landing-intro-bg {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	#landing-intro-bg .row {
		height: 100%;
		text-align: center;
	}
	
	#page-nav {
		position: absolute;
		width: 100%;
	}

</style>